module.exports = __webpack_public_path__ + "img/item8.ed83ffcd.png";